<template>
    <div class="page-block__item">
        <div class="page-block__item-content">
            <div class="layout">
                <div class="layout__item u-1/3-desk">
                    <span class="page-block__item-content-title">
                        {{ trans('hosting.ssl') }}
                    </span>
                </div>
                <!--
             -->
                <div class="layout__item u-2/3-desk">
                    <status-label :status="status"/>
                </div>
            </div>
        </div>
        <div class="page-block__item-nav">
            <button @click="enableSsl" v-if="customerConfig.ssl === 'OFF'" type="button" class="btn btn--ghost btn--ghost-full-width">
                {{ trans('hosting.settings.ssl-enable') }}
            </button>

            <button @click="disableSsl" v-if="customerConfig.ssl === 'ON'" type="button" class="btn btn--ghost btn--ghost-full-width">
                {{ trans('hosting.settings.ssl-disable') }}
            </button>
        </div>
    </div>
</template>

<script>
import HostingApi from '../services/api/hosting.js';
import { EventBus } from "relapp-event/src/event";
import { StatusLabel } from "relapp-technical-management";

export default {
    components: {
        StatusLabel,
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        customerConfig: {
            type: Object,
            required: true
        }
    },
    methods: {
        enableSsl() {
            HostingApi.modifyCustomer(this.domain, { enableSsl: true })
                .then(response => {
                    this.customerConfig.ssl = 'ON';

                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('action.updated')
                    });
                })
                .catch(function (result) {
                    EventBus.$emit('notification', {
                        type: 'error',
                        message: result.data.message
                    });
                });
        },

        disableSsl() {
            HostingApi.modifyCustomer(this.domain, { enableSsl: false })
                .then(response => {
                    this.customerConfig.ssl = 'OFF';

                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('action.updated')
                    });
                })
                .catch(function (result) {
                    EventBus.$emit('notification', {
                        type: 'error',
                        message: result.data.message
                    });
                });
        },
    },
    computed: {
        /**
         * Status label.
         *
         * @return {string}
         */
        status() {
            if (this.customerConfig.ssl === 'ON') {
                return 'active';
            } else {
                return 'inactive';
            }
        }
    }
};
</script>
